import React, { useContext } from "react"

export const ApiContext = React.createContext(null);

export default function useAPI() {
  const api = useContext(ApiContext);

  return api;
}
